export type Co2Band = 'goed' | 'matig' | 'slecht';

export function co2Band(ppm: number): Co2Band {
  if (ppm < 800) return 'goed';
  if (ppm < 1200) return 'matig';
  return 'slecht';
}

export const CO2_ADVICE: Record<Co2Band, string> = {
  goed: 'Frisse lucht',
  matig: 'Ventileren helpt',
  slecht: 'Nu ventileren',
};

export function nl(value: number, digits = 1): string {
  return value.toLocaleString('nl-NL', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
